







































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import {
  List,
  Sticky,
  Popup,
  Toast,
  Swipe,
  SwipeItem,
  ImagePreview,
} from 'vant';
import { checkInfo, getDetail, checkUser, checkVoteNum } from '../api';
import clounbtn from '../components/CloundbtnInfoLoad.vue';
import VoteButton from '../components/VotebuttonTesstNew.vue';
import XGplayer from '../components/XGplayer.vue';

Vue.use(List)
  .use(Sticky)
  .use(Popup)
  .use(Swipe)
  .use(ImagePreview)
  .use(SwipeItem);

@Component({
  components: {
    clounbtn,
    VoteButton,
    XGplayer,
  },
})
export default class Home extends Vue {
  headimg: any = '';
  btnimg: any = require('../assets/search/btnvote.png');
  unionid: string | null = '';
  inway: any = '';
  rankinfo: any = {};
  info: any = {};
  user: any = {};
  voteName: string = '2023project/q2/2023byd_drbs';
  checkzp: any = {};
  cover: any = '';
  videourl: string = '';
  userId: any = '';
  showSuccess: boolean = false;
  titleCoverList: any[] = [];
  classOption: any = { limitMoveNum: 1, direction: 2, step: 1 };
  canshow: boolean = false;
  canvote: boolean = true;
  // votetimelist: any = {
  //   //投票时间
  //   voteysstr: 1688598000000, //2023-07-06 07:00:00
  //   // voteysend: 1689156000000, //2023-07-12 18:00:00
  //   voteysend: 1689177600000, //2023-07-13 00:00:00
  //   votecsstr: 1691078400000, //2023-08-04 00:00:00
  //   votecsend: 1691661600000, //2023-08-10 18:00:00
  //   votejsstr: 1693065600000, //2023-08-27 00:00:00
  //   votejsend: 1693389600000, //2023-08-30 18:00:00
  // };
  votetimelist: any = {
    //投票时间
    voteysstr: 1688598000000, //2023-07-06 07:00:00
    // voteysend: 1689156000000, //2023-07-12 18:00:00
    voteysend: 1689177600000, //2023-07-13 00:00:00
    votecsstr: 1690214400000, //2023-07-25 00:00:00
    votecsend: 1691337600000, //2023-08-07 00:00:00
    votejsstr: 1691510400000, //2023-08-09 00:00:00
    votejsend: 1692720000000, //2023-08-23 00:00:00
  };
  async created() {
    console.log('this.$route.query.canvote::', this.$route.query.canvote);
    this.canvote = this.$route.query.canvote as any;
    this.inway = this.$route.query.inway + '';
    this.userId = this.$route.query.userId + '';
    this.unionid = window.localStorage.getItem('unionid') + '';
    getDetail(this.userId, this.inway).then((res: any) => {
      if (res.code === 200) {
        this.rankinfo = res.data;
      } else {
        if (res.code !== 400) {
          Toast(res.msg);
        }
      }
    });
    checkInfo(this.userId, this.inway).then((res: any) => {
      if (res.code === 200) {
        this.info = res.data;
        this.titleCoverList = this.info.cover.split('|');
        const cover = this.info.cover.split('|');
        this.cover = cover.length > 0 ? cover[0] : '';
        const vidurl = this.info.videoStr.split('|');
        this.videourl = vidurl ? vidurl[0] : '';
      } else {
        if (res.code !== 400) {
          Toast(res.msg);
        }
      }
    });
    checkUser(this.userId).then((res: any) => {
      if (res.code === 200) {
        this.user = res.data;
        this.headimg = res.data.wxheadimg;
      } else {
        if (res.code !== 400) {
          Toast(res.msg);
        }
      }
    });
    checkVoteNum(this.unionid).then((res: any) => {
      if (res.code === 200) {
        if (
          parseInt(res.data.votelimit ? res.data.votelimit : '0') <
          parseInt(res.data.baseuser_limit)
        ) {
          // console.log(
          //   'this.canshow1:::',
          //   parseInt(res.data.votelimit),
          //   parseInt(res.data.baseuser_limit),
          // );
          this.canshow = true;
          return;
        } else {
          // console.log(
          //   'this.canshow2:::',
          //   parseInt(res.data.votelimit),
          //   parseInt(res.data.baseuser_limit),
          // );
          this.canshow = false;
          this.btnimg = require('../assets/search/cannotvote.png');
          return;
        }
      } else {
        this.btnimg = require('../assets/search/cannotvote.png');
        if (res.code !== 400) {
          Toast(res.msg);
        }
      }
    });
    this.getvotetime();
  }
  getvotetime() {
    const nowtime = parseInt(new Date().getTime() + '');
    // console.log('nowtime:::::', nowtime);
    if (
      parseInt(this.votetimelist.voteysstr) < nowtime &&
      parseInt(this.votetimelist.voteysend) > nowtime
    ) {
      this.canvote = false;
    }
    if (
      parseInt(this.votetimelist.votecsstr) < nowtime &&
      parseInt(this.votetimelist.votecsend) > nowtime
    ) {
      this.canvote = false;
    }
    if (
      parseInt(this.votetimelist.votejsstr) < nowtime &&
      parseInt(this.votetimelist.votejsend) > nowtime
    ) {
      this.canvote = false;
    }
  }
  goback() {
    this.$router.push('index');
  }
  showImage(data: any, index: number) {
    ImagePreview({
      images: data,
      startPosition: index,
    });
  }
  votSuccess(num: any) {
    this.showSuccess = !this.showSuccess;
    this.rankinfo.votes = num;
    // window.location.reload();
  }
}
